import React, { PureComponent } from 'react';

import { Grid, Cell } from 'formlabs-web-components/Grid';
import { Header, Eyebrow } from 'formlabs-web-components/Type';
import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import { Button } from 'formlabs-web-components/Link';
import { withTranslation } from 'react-i18next';
import Card from '../../../../common/components/content/Card';
import CountryContext from '../../../../common/context/country';
import './Resources.module.css';
const ResourcePostsList = DisplayComponent(
  class ResourcePostsList extends PureComponent {
    state = {
      selectedCollection: 0
    };
    static contextType = CountryContext;
    handleCollectionChange = selectedCollection => {
      this.setState({ selectedCollection });
    };
    render() {
      const { collections, classes, basePath, t } = this.props;
      const { selectedCollection } = this.state;
      const { path } = this.context;
      const selectedCollectionFull = collections[selectedCollection];

      const resources = selectedCollectionFull.subCollections.reduce(
        (result, subCollection) => {
          subCollection.resources.forEach(resource => {
            result.push(resource);
          });
          return result;
        },
        []
      );

      return (
        <div styleName="resource-posts-list" className={classes}>
          <Grid direction="x">
            <Cell largeSize={8} backgroundColor="blue">
              <div styleName="collection-list-container">
                <p>
                  <strong>{t('Resource Collections')}</strong>
                </p>
                <hr />
                <div styleName="selector-wrapper">
                  {collections.map((collection, i) => {
                    return (
                      <button
                        styleName={
                          selectedCollectionFull.title === collection.title
                            ? 'collection-selected'
                            : 'collection-list'
                        }
                        key={collection.title}
                        onClick={() => this.handleCollectionChange(i)}
                      >
                        {collection.title}
                      </button>
                    );
                  })}
                </div>
              </div>
            </Cell>
            <Cell largeSize={16}>
              <div styleName="single-collection-list">
                <Header level={6} displayAs={6} weight={600}>
                  {selectedCollectionFull.title}
                </Header>
                <hr />
                {resources.slice(0, 6).map(resource => (
                  <div
                    styleName="single-item"
                    key={`${resource.url} ${resource.title}`}
                  >
                    <Card
                      url={resource.url}
                      bgColor="transparent-black"
                      hover="none"
                      image={resource.smallImage}
                      imageConstraint="90px"
                      imagePosition="left"
                      unresponsive={true}
                      padding="0"
                      internalPadding="none"
                      eyebrowText={resource.type}
                      titleStyle="micro"
                      title={resource.title}
                    />
                  </div>
                ))}
                {resources.length > 6 && (
                  <Button
                    color="light"
                    url={`${basePath}${selectedCollectionFull.slug}/`}
                  >
                    {t('See all {{count}} Resources', {
                      count: resources.length
                    })}
                  </Button>
                )}
              </div>
            </Cell>
          </Grid>
        </div>
      );
    }
  }
);

ResourcePostsList.propTypes = {};

export default withTranslation()(ResourcePostsList);
